import { render, staticRenderFns } from "./PromoCodeTable.vue?vue&type=template&id=20795352&scoped=true"
import script from "./PromoCodeTable.vue?vue&type=script&lang=js"
export * from "./PromoCodeTable.vue?vue&type=script&lang=js"
import style0 from "./PromoCodeTable.vue?vue&type=style&index=0&id=20795352&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20795352",
  null
  
)

export default component.exports